// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @import './node_modules/dockview/dist/styles/dockview.css'; */

/* Custom added */
.split-view-container .view-container {
    background-color: rgb(250 250 250 / var(--tw-bg-opacity)) !important;
  }

  .dockview-theme-replit .groupview.active-group {
    border: 1px solid transparent !important;
  }
  .dockview-theme-replit .groupview.inactive-group {
    border: 1px solid transparent !important;
  }
/* Custom added end */

.dockview-svg {
    display: inline-block;
    fill: currentcolor;
    line-height: 1;
    stroke: currentcolor;
    stroke-width: 0;
  }
  .dockview-theme-dark {
    --dv-background-color: black;
    --dv-paneview-active-outline-color: dodgerblue;
    --dv-tabs-and-actions-container-font-size: 13px;
    --dv-tabs-and-actions-container-height: 35px;
    --dv-drag-over-background-color: rgba(83, 89, 93, 0.5);
    --dv-drag-over-border-color: white;
    --dv-tabs-container-scrollbar-color: #888;
    --dv-icon-hover-background-color: rgba(90, 93, 94, 0.31);
    --dv-floating-box-shadow: 8px 8px 8px 0px rgba(83, 89, 93, 0.5);
    --dv-group-view-background-color: #1e1e1e;
    --dv-tabs-and-actions-container-background-color: #252526;
    --dv-activegroup-visiblepanel-tab-background-color: #1e1e1e;
    --dv-activegroup-hiddenpanel-tab-background-color: #2d2d2d;
    --dv-inactivegroup-visiblepanel-tab-background-color: #1e1e1e;
    --dv-inactivegroup-hiddenpanel-tab-background-color: #2d2d2d;
    --dv-tab-divider-color: #1e1e1e;
    --dv-activegroup-visiblepanel-tab-color: white;
    --dv-activegroup-hiddenpanel-tab-color: #969696;
    --dv-inactivegroup-visiblepanel-tab-color: #8f8f8f;
    --dv-inactivegroup-hiddenpanel-tab-color: #626262;
    --dv-separator-border: rgb(68, 68, 68);
    --dv-paneview-header-border-color: rgba(204, 204, 204, 0.2);
  }
  
  .dockview-theme-light {
    --dv-background-color: black;
    --dv-paneview-active-outline-color: dodgerblue;
    --dv-tabs-and-actions-container-font-size: 13px;
    --dv-tabs-and-actions-container-height: 35px;
    --dv-drag-over-background-color: rgba(83, 89, 93, 0.5);
    --dv-drag-over-border-color: white;
    --dv-tabs-container-scrollbar-color: #888;
    --dv-icon-hover-background-color: rgba(90, 93, 94, 0.31);
    --dv-floating-box-shadow: 8px 8px 8px 0px rgba(83, 89, 93, 0.5);
    --dv-group-view-background-color: white;
    --dv-tabs-and-actions-container-background-color: #f3f3f3;
    --dv-activegroup-visiblepanel-tab-background-color: white;
    --dv-activegroup-hiddenpanel-tab-background-color: #ececec;
    --dv-inactivegroup-visiblepanel-tab-background-color: white;
    --dv-inactivegroup-hiddenpanel-tab-background-color: #ececec;
    --dv-tab-divider-color: white;
    --dv-activegroup-visiblepanel-tab-color: rgb(51, 51, 51);
    --dv-activegroup-hiddenpanel-tab-color: rgba(51, 51, 51, 0.7);
    --dv-inactivegroup-visiblepanel-tab-color: rgba(51, 51, 51, 0.7);
    --dv-inactivegroup-hiddenpanel-tab-color: rgba(51, 51, 51, 0.35);
    --dv-separator-border: rgba(128, 128, 128, 0.35);
    --dv-paneview-header-border-color: rgb(51, 51, 51);
  }
  
  .dockview-theme-vs {
    --dv-background-color: black;
    --dv-paneview-active-outline-color: dodgerblue;
    --dv-drag-over-background-color: rgba(83, 89, 93, 0.5);
    --dv-drag-over-border-color: white;
    --dv-tabs-container-scrollbar-color: #888;
    --dv-icon-hover-background-color: rgba(90, 93, 94, 0.31);
    --dv-floating-box-shadow: 8px 8px 8px 0px rgba(83, 89, 93, 0.5);
    --dv-group-view-background-color: #1e1e1e;
    --dv-tabs-and-actions-container-background-color: #252526;
    --dv-activegroup-visiblepanel-tab-background-color: #1e1e1e;
    --dv-activegroup-hiddenpanel-tab-background-color: #2d2d2d;
    --dv-inactivegroup-visiblepanel-tab-background-color: #1e1e1e;
    --dv-inactivegroup-hiddenpanel-tab-background-color: #2d2d2d;
    --dv-tab-divider-color: #1e1e1e;
    --dv-activegroup-hiddenpanel-tab-color: #969696;
    --dv-inactivegroup-visiblepanel-tab-color: #8f8f8f;
    --dv-inactivegroup-hiddenpanel-tab-color: #626262;
    --dv-separator-border: rgb(68, 68, 68);
    --dv-paneview-header-border-color: rgba(204, 204, 204, 0.2);
    --dv-tabs-and-actions-container-background-color: #2d2d30;
    --dv-tabs-and-actions-container-height: 20px;
    --dv-tabs-and-actions-container-font-size: 11px;
    --dv-activegroup-visiblepanel-tab-background-color: #007acc;
    --dv-inactivegroup-visiblepanel-tab-background-color: #3f3f46;
    --dv-activegroup-visiblepanel-tab-color: white;
    --dv-activegroup-hiddenpanel-tab-color: white;
    --dv-inactivegroup-visiblepanel-tab-color: white;
    --dv-inactivegroup-hiddenpanel-tab-color: white;
  }
  .dockview-theme-vs .groupview.active-group > .tabs-and-actions-container {
    box-sizing: content-box;
    border-bottom: 2px solid var(--dv-activegroup-visiblepanel-tab-background-color);
  }
  .dockview-theme-vs .groupview.active-group > .tabs-and-actions-container .tab.active-tab {
    border-top: 2px solid var(--dv-activegroup-visiblepanel-tab-background-color);
  }
  .dockview-theme-vs .groupview.active-group > .tabs-and-actions-container .tab.inactive-tab {
    border-top: 2px solid var(--dv-activegroup-hiddenpanel-tab-background-color);
  }
  .dockview-theme-vs .groupview.inactive-group > .tabs-and-actions-container {
    box-sizing: content-box;
    border-bottom: 2px solid var(--dv-inactivegroup-visiblepanel-tab-background-color);
  }
  .dockview-theme-vs .groupview.inactive-group > .tabs-and-actions-container .tab.active-tab {
    border-top: 2px solid var(--dv-inactivegroup-visiblepanel-tab-background-color);
  }
  .dockview-theme-vs .groupview.inactive-group > .tabs-and-actions-container .tab.inactive-tab {
    border-top: 2px solid var(--dv-inactivegroup-hiddenpanel-tab-background-color);
  }
  
  .dockview-theme-abyss {
    --dv-background-color: black;
    --dv-paneview-active-outline-color: dodgerblue;
    --dv-tabs-and-actions-container-font-size: 13px;
    --dv-tabs-and-actions-container-height: 35px;
    --dv-drag-over-background-color: rgba(83, 89, 93, 0.5);
    --dv-drag-over-border-color: white;
    --dv-tabs-container-scrollbar-color: #888;
    --dv-icon-hover-background-color: rgba(90, 93, 94, 0.31);
    --dv-floating-box-shadow: 8px 8px 8px 0px rgba(83, 89, 93, 0.5);
    --dv-group-view-background-color: #000c18;
    --dv-tabs-and-actions-container-background-color: #1c1c2a;
    --dv-activegroup-visiblepanel-tab-background-color: #000c18;
    --dv-activegroup-hiddenpanel-tab-background-color: #10192c;
    --dv-inactivegroup-visiblepanel-tab-background-color: #000c18;
    --dv-inactivegroup-hiddenpanel-tab-background-color: #10192c;
    --dv-tab-divider-color: #2b2b4a;
    --dv-activegroup-visiblepanel-tab-color: white;
    --dv-activegroup-hiddenpanel-tab-color: rgba(255, 255, 255, 0.5);
    --dv-inactivegroup-visiblepanel-tab-color: rgba(255, 255, 255, 0.5);
    --dv-inactivegroup-hiddenpanel-tab-color: rgba(255, 255, 255, 0.25);
    --dv-separator-border: #2b2b4a;
    --dv-paneview-header-border-color: #2b2b4a;
    --dv-paneview-active-outline-color: #596f99;
  }
  
  .dockview-theme-dracula {
    --dv-background-color: black;
    --dv-paneview-active-outline-color: dodgerblue;
    --dv-tabs-and-actions-container-font-size: 13px;
    --dv-tabs-and-actions-container-height: 35px;
    --dv-drag-over-background-color: rgba(83, 89, 93, 0.5);
    --dv-drag-over-border-color: white;
    --dv-tabs-container-scrollbar-color: #888;
    --dv-icon-hover-background-color: rgba(90, 93, 94, 0.31);
    --dv-floating-box-shadow: 8px 8px 8px 0px rgba(83, 89, 93, 0.5);
    --dv-group-view-background-color: #282a36;
    --dv-tabs-and-actions-container-background-color: #191a21;
    --dv-activegroup-visiblepanel-tab-background-color: #282a36;
    --dv-activegroup-hiddenpanel-tab-background-color: #21222c;
    --dv-inactivegroup-visiblepanel-tab-background-color: #282a36;
    --dv-inactivegroup-hiddenpanel-tab-background-color: #21222c;
    --dv-tab-divider-color: #191a21;
    --dv-activegroup-visiblepanel-tab-color: rgb(248, 248, 242);
    --dv-activegroup-hiddenpanel-tab-color: rgb(98, 114, 164);
    --dv-inactivegroup-visiblepanel-tab-color: rgba(248, 248, 242, 0.5);
    --dv-inactivegroup-hiddenpanel-tab-color: rgba(98, 114, 164, 0.5);
    --dv-separator-border: #bd93f9;
    --dv-paneview-header-border-color: #bd93f9;
    --dv-paneview-active-outline-color: #6272a4;
  }
  .dockview-theme-dracula .groupview.active-group > .tabs-and-actions-container > .tabs-container > .tab.active-tab {
    position: relative;
  }
  .dockview-theme-dracula .groupview.active-group > .tabs-and-actions-container > .tabs-container > .tab.active-tab::after {
    position: absolute;
    left: 0px;
    top: 0px;
    content: "";
    width: 100%;
    height: 1px;
    background-color: #94527e;
    z-index: 999;
  }
  .dockview-theme-dracula .groupview.inactive-group > .tabs-and-actions-container > .tabs-container > .tab.active-tab {
    position: relative;
  }
  .dockview-theme-dracula .groupview.inactive-group > .tabs-and-actions-container > .tabs-container > .tab.active-tab::after {
    position: absolute;
    left: 0px;
    bottom: 0px;
    content: "";
    width: 100%;
    height: 1px;
    background-color: #5e3d5a;
    z-index: 999;
  }
  
  .dockview-theme-replit {
    --dv-background-color: black;
    --dv-paneview-active-outline-color: dodgerblue;
    --dv-tabs-and-actions-container-font-size: 13px;
    --dv-tabs-and-actions-container-height: 35px;
    --dv-drag-over-background-color: rgba(83, 89, 93, 0.5);
    --dv-drag-over-border-color: white;
    --dv-tabs-container-scrollbar-color: #888;
    --dv-icon-hover-background-color: rgba(90, 93, 94, 0.31);
    --dv-floating-box-shadow: 8px 8px 8px 0px rgba(83, 89, 93, 0.5);
    --dv-group-view-background-color: #ebeced;
    --dv-tabs-and-actions-container-background-color: #fcfcfc;
    --dv-activegroup-visiblepanel-tab-background-color: #f0f1f2;
    --dv-activegroup-hiddenpanel-tab-background-color: ##fcfcfc;
    --dv-inactivegroup-visiblepanel-tab-background-color: #f0f1f2;
    --dv-inactivegroup-hiddenpanel-tab-background-color: #fcfcfc;
    --dv-tab-divider-color: transparent;
    --dv-activegroup-visiblepanel-tab-color: rgb(51, 51, 51);
    --dv-activegroup-hiddenpanel-tab-color: rgb(51, 51, 51);
    --dv-inactivegroup-visiblepanel-tab-color: rgb(51, 51, 51);
    --dv-inactivegroup-hiddenpanel-tab-color: rgb(51, 51, 51);
    --dv-separator-border: transparent;
    --dv-paneview-header-border-color: rgb(51, 51, 51);
    --dv-background-color: #ebeced;
    --dv-separator-handle-background-color: #cfd1d3;
    --dv-separator-handle-hover-background-color: #babbbb;
  }
  .dockview-theme-replit .dv-resize-container:has(> .groupview) {
    border-radius: 8px;
  }
  .dockview-theme-replit .groupview {
    overflow: hidden;
    border-radius: 10px;
  }
  .dockview-theme-replit .groupview .tabs-and-actions-container {
    border-bottom: 1px solid rgba(128, 128, 128, 0.35);
  }
  .dockview-theme-replit .groupview .tabs-and-actions-container .tab {
    margin: 4px;
    border-radius: 8px;
  }
  .dockview-theme-replit .groupview .tabs-and-actions-container .tab .dockview-svg {
    height: 8px;
    width: 8px;
  }
  .dockview-theme-replit .groupview .tabs-and-actions-container .tab:hover {
    background-color: #e4e5e6 !important;
  }
  .dockview-theme-replit .groupview .content-container {
    background-color: #fcfcfc;
  }
  .dockview-theme-replit .groupview.active-group {
    border: 1px solid rgba(128, 128, 128, 0.35);
  }
  .dockview-theme-replit .groupview.inactive-group {
    border: 1px solid transparent;
  }
  .dockview-theme-replit .vertical > .sash-container > .sash:not(.disabled)::after {
    content: "";
    height: 4px;
    width: 40px;
    border-radius: 2px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: var(--dv-separator-handle-background-color);
    position: absolute;
  }
  .dockview-theme-replit .vertical > .sash-container > .sash:not(.disabled):hover::after {
    background-color: var(--dv-separator-handle-hover-background-color);
  }
  .dockview-theme-replit .horizontal > .sash-container > .sash:not(.disabled)::after {
    content: "";
    height: 40px;
    width: 4px;
    border-radius: 2px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: var(--dv-separator-handle-background-color);
    position: absolute;
  }
  .dockview-theme-replit .horizontal > .sash-container > .sash:not(.disabled):hover::after {
    background-color: var(--dv-separator-handle-hover-background-color);
  }
  .drop-target {
    position: relative;
  }
  .drop-target > .drop-target-dropzone {
    position: absolute;
    left: 0px;
    top: 0px;
    height: 100%;
    width: 100%;
    z-index: 1000;
    pointer-events: none;
  }
  .drop-target > .drop-target-dropzone > .drop-target-selection {
    position: relative;
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    background-color: var(--dv-drag-over-background-color);
    transition: top 70ms ease-out, left 70ms ease-out, width 70ms ease-out, height 70ms ease-out, opacity 0.15s ease-out;
    will-change: transform;
    pointer-events: none;
  }
  .drop-target > .drop-target-dropzone > .drop-target-selection.dv-drop-target-top.dv-drop-target-small-vertical {
    border-top: 1px solid var(--dv-drag-over-border-color);
  }
  .drop-target > .drop-target-dropzone > .drop-target-selection.dv-drop-target-bottom.dv-drop-target-small-vertical {
    border-bottom: 1px solid var(--dv-drag-over-border-color);
  }
  .drop-target > .drop-target-dropzone > .drop-target-selection.dv-drop-target-left.dv-drop-target-small-horizontal {
    border-left: 1px solid var(--dv-drag-over-border-color);
  }
  .drop-target > .drop-target-dropzone > .drop-target-selection.dv-drop-target-right.dv-drop-target-small-horizontal {
    border-right: 1px solid var(--dv-drag-over-border-color);
  }
  .dv-dockview {
    position: relative;
    background-color: var(--dv-group-view-background-color);
  }
  .dv-dockview .dv-watermark-container {
    position: absolute;
    top: 0px;
    left: 0px;
    height: 100%;
    width: 100%;
    z-index: 1;
  }
  .dv-dockview .dv-overlay-render-container {
    position: relative;
  }
  
  .groupview.active-group > .tabs-and-actions-container > .tabs-container > .tab.active-tab {
    background-color: var(--dv-activegroup-visiblepanel-tab-background-color);
    color: var(--dv-activegroup-visiblepanel-tab-color);
  }
  .groupview.active-group > .tabs-and-actions-container > .tabs-container > .tab.inactive-tab {
    background-color: var(--dv-activegroup-hiddenpanel-tab-background-color);
    color: var(--dv-activegroup-hiddenpanel-tab-color);
  }
  .groupview.inactive-group > .tabs-and-actions-container > .tabs-container > .tab.active-tab {
    background-color: var(--dv-inactivegroup-visiblepanel-tab-background-color);
    color: var(--dv-inactivegroup-visiblepanel-tab-color);
  }
  .groupview.inactive-group > .tabs-and-actions-container > .tabs-container > .tab.inactive-tab {
    background-color: var(--dv-inactivegroup-hiddenpanel-tab-background-color);
    color: var(--dv-inactivegroup-hiddenpanel-tab-color);
  }
  
  /**
   * when a tab is dragged we lose the above stylings because they are conditional on parent elements
   * therefore we also set some stylings for the dragging event
   **/
  .tab.dv-tab-dragging {
    background-color: var(--dv-activegroup-visiblepanel-tab-background-color);
    color: var(--dv-activegroup-visiblepanel-tab-color);
  }
  .groupview {
    display: flex;
    flex-direction: column;
    height: 100%;
    background-color: var(--dv-group-view-background-color);
    overflow: hidden;
  }
  .groupview:focus {
    outline: none;
  }
  .groupview.empty > .tabs-and-actions-container {
    display: none;
  }
  .groupview > .content-container {
    flex-grow: 1;
    min-height: 0;
    outline: none;
  }
  .dv-root-wrapper {
    height: 100%;
    width: 100%;
  }
  .grid-view,
  .branch-node {
    height: 100%;
    width: 100%;
  }
  .dv-debug .dv-resize-container .dv-resize-handle-top {
    background-color: red;
  }
  .dv-debug .dv-resize-container .dv-resize-handle-bottom {
    background-color: green;
  }
  .dv-debug .dv-resize-container .dv-resize-handle-left {
    background-color: yellow;
  }
  .dv-debug .dv-resize-container .dv-resize-handle-right {
    background-color: blue;
  }
  .dv-debug .dv-resize-container .dv-resize-handle-topleft,
  .dv-debug .dv-resize-container .dv-resize-handle-topright,
  .dv-debug .dv-resize-container .dv-resize-handle-bottomleft,
  .dv-debug .dv-resize-container .dv-resize-handle-bottomright {
    background-color: cyan;
  }
  
  .dv-resize-container {
    position: absolute;
    z-index: 997;
    border: 1px solid var(--dv-tab-divider-color);
    box-shadow: var(--dv-floating-box-shadow);
  }
  .dv-resize-container.dv-resize-container-dragging {
    opacity: 0.5;
  }
  .dv-resize-container .dv-resize-handle-top {
    height: 4px;
    width: calc(100% - 8px);
    left: 4px;
    top: -2px;
    z-index: 999;
    position: absolute;
    cursor: ns-resize;
  }
  .dv-resize-container .dv-resize-handle-bottom {
    height: 4px;
    width: calc(100% - 8px);
    left: 4px;
    bottom: -2px;
    z-index: 999;
    position: absolute;
    cursor: ns-resize;
  }
  .dv-resize-container .dv-resize-handle-left {
    height: calc(100% - 8px);
    width: 4px;
    left: -2px;
    top: 4px;
    z-index: 999;
    position: absolute;
    cursor: ew-resize;
  }
  .dv-resize-container .dv-resize-handle-right {
    height: calc(100% - 8px);
    width: 4px;
    right: -2px;
    top: 4px;
    z-index: 999;
    position: absolute;
    cursor: ew-resize;
  }
  .dv-resize-container .dv-resize-handle-topleft {
    height: 4px;
    width: 4px;
    top: -2px;
    left: -2px;
    z-index: 999;
    position: absolute;
    cursor: nw-resize;
  }
  .dv-resize-container .dv-resize-handle-topright {
    height: 4px;
    width: 4px;
    right: -2px;
    top: -2px;
    z-index: 999;
    position: absolute;
    cursor: ne-resize;
  }
  .dv-resize-container .dv-resize-handle-bottomleft {
    height: 4px;
    width: 4px;
    left: -2px;
    bottom: -2px;
    z-index: 999;
    position: absolute;
    cursor: sw-resize;
  }
  .dv-resize-container .dv-resize-handle-bottomright {
    height: 4px;
    width: 4px;
    right: -2px;
    bottom: -2px;
    z-index: 999;
    position: absolute;
    cursor: se-resize;
  }
  .dv-render-overlay {
    position: absolute;
    z-index: 1;
    height: 100%;
  }
  .dv-render-overlay.dv-render-overlay-float {
    z-index: 998;
  }
  .dv-debug .dv-render-overlay {
    outline: 1px solid red;
    outline-offset: -1;
  }
  .pane-container {
    height: 100%;
    width: 100%;
  }
  .pane-container.animated .view {
    transition-duration: 0.15s;
    transition-timing-function: ease-out;
  }
  .pane-container .view {
    overflow: hidden;
    display: flex;
    flex-direction: column;
    padding: 0px !important;
  }
  .pane-container .view:not(:first-child)::before {
    background-color: transparent !important;
  }
  .pane-container .view:not(:first-child) .pane > .pane-header {
    border-top: 1px solid var(--dv-paneview-header-border-color);
  }
  .pane-container .view .default-header {
    background-color: var(--dv-group-view-background-color);
    color: var(--dv-activegroup-visiblepanel-tab-color);
    display: flex;
    padding: 0px 8px;
    cursor: pointer;
  }
  .pane-container .view .default-header .dockview-pane-header-icon {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .pane-container .view .default-header > span {
    padding-left: 8px;
    flex-grow: 1;
  }
  .pane-container:first-of-type > .pane > .pane-header {
    border-top: none !important;
  }
  .pane-container .pane {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    height: 100%;
  }
  .pane-container .pane .pane-header {
    box-sizing: border-box;
    -webkit-user-select: none;
       -moz-user-select: none;
            user-select: none;
    position: relative;
    outline: none;
  }
  .pane-container .pane .pane-header.pane-draggable {
    cursor: pointer;
  }
  .pane-container .pane .pane-header:focus:before, .pane-container .pane .pane-header:focus-within:before {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 5;
    content: "";
    pointer-events: none;
    outline: 1px solid;
    outline-width: -1px;
    outline-style: solid;
    outline-offset: -1px;
    outline-color: var(--dv-paneview-active-outline-color);
  }
  .pane-container .pane .pane-body {
    overflow-y: auto;
    overflow-x: hidden;
    flex-grow: 1;
    position: relative;
    outline: none;
  }
  .pane-container .pane .pane-body:focus:before, .pane-container .pane .pane-body:focus-within:before {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 5;
    content: "";
    pointer-events: none;
    outline: 1px solid;
    outline-width: -1px;
    outline-style: solid;
    outline-offset: -1px;
    outline-color: var(--dv-paneview-active-outline-color);
  }
  .dv-debug .split-view-container .sash-container .sash.enabled {
    background-color: black;
  }
  .dv-debug .split-view-container .sash-container .sash.disabled {
    background-color: orange;
  }
  .dv-debug .split-view-container .sash-container .sash.maximum {
    background-color: green;
  }
  .dv-debug .split-view-container .sash-container .sash.minimum {
    background-color: red;
  }
  
  .split-view-container {
    position: relative;
    overflow: hidden;
    height: 100%;
    width: 100%;
  }
  .split-view-container.dv-splitview-disabled > .sash-container > .sash {
    pointer-events: none;
  }
  .split-view-container.animation .view,
  .split-view-container.animation .sash {
    transition-duration: 0.15s;
    transition-timing-function: ease-out;
  }
  .split-view-container.horizontal {
    height: 100%;
  }
  .split-view-container.horizontal > .sash-container > .sash {
    height: 100%;
    width: 4px;
  }
  .split-view-container.horizontal > .sash-container > .sash.enabled {
    cursor: ew-resize;
  }
  .split-view-container.horizontal > .sash-container > .sash.disabled {
    cursor: default;
  }
  .split-view-container.horizontal > .sash-container > .sash.maximum {
    cursor: w-resize;
  }
  .split-view-container.horizontal > .sash-container > .sash.minimum {
    cursor: e-resize;
  }
  .split-view-container.horizontal > .view-container > .view:not(:first-child)::before {
    height: 100%;
    width: 1px;
  }
  .split-view-container.vertical {
    width: 100%;
  }
  .split-view-container.vertical > .sash-container > .sash {
    width: 100%;
    height: 4px;
  }
  .split-view-container.vertical > .sash-container > .sash.enabled {
    cursor: ns-resize;
  }
  .split-view-container.vertical > .sash-container > .sash.disabled {
    cursor: default;
  }
  .split-view-container.vertical > .sash-container > .sash.maximum {
    cursor: n-resize;
  }
  .split-view-container.vertical > .sash-container > .sash.minimum {
    cursor: s-resize;
  }
  .split-view-container.vertical > .view-container > .view {
    width: 100%;
  }
  .split-view-container.vertical > .view-container > .view:not(:first-child)::before {
    height: 1px;
    width: 100%;
  }
  .split-view-container .sash-container {
    height: 100%;
    width: 100%;
    position: absolute;
  }
  .split-view-container .sash-container .sash {
    position: absolute;
    z-index: 99;
    outline: none;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    touch-action: none;
  }
  .split-view-container .sash-container .sash:not(.disabled):active {
    transition: background-color 0.1s ease-in-out;
    background-color: var(--dv-active-sash-color, transparent);
  }
  .split-view-container .sash-container .sash:not(.disabled):hover {
    background-color: var(--dv-active-sash-color, transparent);
    transition: background-color 0.1s ease-in-out;
    transition-delay: 0.5s;
  }
  .split-view-container .view-container {
    position: relative;
    height: 100%;
    width: 100%;
    background-color: var(--dv-background-color);
  }
  .split-view-container .view-container .view {
    height: 100%;
    box-sizing: border-box;
    overflow: auto;
    position: absolute;
  }
  .split-view-container.separator-border .view:not(:first-child)::before {
    content: " ";
    position: absolute;
    top: 0;
    left: 0;
    z-index: 5;
    pointer-events: none;
    background-color: var(--dv-separator-border);
  }
  .dv-dragged {
    transform: translate3d(0px, 0px, 0px); /* forces tab to be drawn on a separate layer (see https://github.com/microsoft/vscode/issues/18733) */
  }
  
  .tab {
    flex-shrink: 0;
  }
  .tab:focus-within, .tab:focus {
    position: relative;
  }
  .tab:focus-within::after, .tab:focus::after {
    position: absolute;
    content: "";
    height: 100%;
    width: 100%;
    top: 0px;
    left: 0px;
    pointer-events: none;
    outline: 1px solid var(--dv-tab-divider-color) !important;
    outline-offset: -1px;
    z-index: 5;
  }
  .tab.dv-tab-dragging .dv-default-tab-action {
    background-color: var(--dv-activegroup-visiblepanel-tab-color);
  }
  .tab.active-tab .dv-default-tab .dv-default-tab-action {
    visibility: visible;
  }
  .tab.inactive-tab .dv-default-tab .dv-default-tab-action {
    visibility: hidden;
  }
  .tab.inactive-tab .dv-default-tab:hover .dv-default-tab-action {
    visibility: visible;
  }
  .tab .dv-default-tab {
    position: relative;
    height: 100%;
    display: flex;
    min-width: 80px;
    align-items: center;
    padding: 0px 8px;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .tab .dv-default-tab .dv-default-tab-content {
    padding: 0px 8px;
    flex-grow: 1;
  }
  .tab .dv-default-tab .dv-default-tab-action {
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }
  .tab .dv-default-tab .dv-default-tab-action:hover {
    border-radius: 2px;
    background-color: var(--dv-icon-hover-background-color);
  }
  .tabs-and-actions-container {
    display: flex;
    background-color: var(--dv-tabs-and-actions-container-background-color);
    flex-shrink: 0;
    box-sizing: border-box;
    height: var(--dv-tabs-and-actions-container-height);
    font-size: var(--dv-tabs-and-actions-container-font-size);
  }
  .tabs-and-actions-container.hidden {
    display: none;
  }
  .tabs-and-actions-container.dv-single-tab.dv-full-width-single-tab .tabs-container {
    flex-grow: 1;
  }
  .tabs-and-actions-container.dv-single-tab.dv-full-width-single-tab .tabs-container .tab {
    flex-grow: 1;
  }
  .tabs-and-actions-container.dv-single-tab.dv-full-width-single-tab .void-container {
    flex-grow: 0;
  }
  .tabs-and-actions-container .void-container {
    display: flex;
    flex-grow: 1;
    cursor: grab;
  }
  .tabs-and-actions-container .tabs-container {
    display: flex;
    overflow-x: overlay;
    overflow-y: hidden;
    scrollbar-width: thin;
    /* Track */
    /* Handle */
  }
  .tabs-and-actions-container .tabs-container::-webkit-scrollbar {
    height: 3px;
  }
  .tabs-and-actions-container .tabs-container::-webkit-scrollbar-track {
    background: transparent;
  }
  .tabs-and-actions-container .tabs-container::-webkit-scrollbar-thumb {
    background: var(--dv-tabs-container-scrollbar-color);
  }
  .tabs-and-actions-container .tabs-container .tab {
    -webkit-user-drag: element;
    outline: none;
    min-width: 75px;
    cursor: pointer;
    position: relative;
    box-sizing: border-box;
  }
  .tabs-and-actions-container .tabs-container .tab:not(:first-child)::before {
    content: " ";
    position: absolute;
    top: 0;
    left: 0;
    z-index: 5;
    pointer-events: none;
    background-color: var(--dv-tab-divider-color);
    width: 1px;
    height: 100%;
  }
  .watermark {
    display: flex;
    width: 100%;
  }
  .watermark.has-actions .watermark-title .actions-container {
    display: none;
  }
  .watermark .watermark-title {
    height: 35px;
    width: 100%;
    display: flex;
  }
  .watermark .watermark-content {
    flex-grow: 1;
  }
  .watermark .actions-container {
    display: flex;
    align-items: center;
    padding: 0px 8px;
  }
  .watermark .actions-container .close-action {
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    cursor: pointer;
    color: var(--dv-activegroup-hiddenpanel-tab-color);
  }
  .watermark .actions-container .close-action:hover {
    border-radius: 2px;
    background-color: var(--dv-icon-hover-background-color);
  }`, "",{"version":3,"sources":["webpack://./src/assets/docview.css"],"names":[],"mappings":"AAAA,gEAAgE;;AAEhE,iBAAiB;AACjB;IACI,oEAAoE;EACtE;;EAEA;IACE,wCAAwC;EAC1C;EACA;IACE,wCAAwC;EAC1C;AACF,qBAAqB;;AAErB;IACI,qBAAqB;IACrB,kBAAkB;IAClB,cAAc;IACd,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,4BAA4B;IAC5B,8CAA8C;IAC9C,+CAA+C;IAC/C,4CAA4C;IAC5C,sDAAsD;IACtD,kCAAkC;IAClC,yCAAyC;IACzC,wDAAwD;IACxD,+DAA+D;IAC/D,yCAAyC;IACzC,yDAAyD;IACzD,2DAA2D;IAC3D,0DAA0D;IAC1D,6DAA6D;IAC7D,4DAA4D;IAC5D,+BAA+B;IAC/B,8CAA8C;IAC9C,+CAA+C;IAC/C,kDAAkD;IAClD,iDAAiD;IACjD,sCAAsC;IACtC,2DAA2D;EAC7D;;EAEA;IACE,4BAA4B;IAC5B,8CAA8C;IAC9C,+CAA+C;IAC/C,4CAA4C;IAC5C,sDAAsD;IACtD,kCAAkC;IAClC,yCAAyC;IACzC,wDAAwD;IACxD,+DAA+D;IAC/D,uCAAuC;IACvC,yDAAyD;IACzD,yDAAyD;IACzD,0DAA0D;IAC1D,2DAA2D;IAC3D,4DAA4D;IAC5D,6BAA6B;IAC7B,wDAAwD;IACxD,6DAA6D;IAC7D,gEAAgE;IAChE,gEAAgE;IAChE,gDAAgD;IAChD,kDAAkD;EACpD;;EAEA;IACE,4BAA4B;IAC5B,8CAA8C;IAG9C,sDAAsD;IACtD,kCAAkC;IAClC,yCAAyC;IACzC,wDAAwD;IACxD,+DAA+D;IAC/D,yCAAyC;IACzC,yDAAyD;IACzD,2DAA2D;IAC3D,0DAA0D;IAC1D,6DAA6D;IAC7D,4DAA4D;IAC5D,+BAA+B;IAE/B,+CAA+C;IAC/C,kDAAkD;IAClD,iDAAiD;IACjD,sCAAsC;IACtC,2DAA2D;IAC3D,yDAAyD;IACzD,4CAA4C;IAC5C,+CAA+C;IAC/C,2DAA2D;IAC3D,6DAA6D;IAC7D,8CAA8C;IAC9C,6CAA6C;IAC7C,gDAAgD;IAChD,+CAA+C;EACjD;EACA;IACE,uBAAuB;IACvB,gFAAgF;EAClF;EACA;IACE,6EAA6E;EAC/E;EACA;IACE,4EAA4E;EAC9E;EACA;IACE,uBAAuB;IACvB,kFAAkF;EACpF;EACA;IACE,+EAA+E;EACjF;EACA;IACE,8EAA8E;EAChF;;EAEA;IACE,4BAA4B;IAC5B,8CAA8C;IAC9C,+CAA+C;IAC/C,4CAA4C;IAC5C,sDAAsD;IACtD,kCAAkC;IAClC,yCAAyC;IACzC,wDAAwD;IACxD,+DAA+D;IAC/D,yCAAyC;IACzC,yDAAyD;IACzD,2DAA2D;IAC3D,0DAA0D;IAC1D,6DAA6D;IAC7D,4DAA4D;IAC5D,+BAA+B;IAC/B,8CAA8C;IAC9C,gEAAgE;IAChE,mEAAmE;IACnE,mEAAmE;IACnE,8BAA8B;IAC9B,0CAA0C;IAC1C,2CAA2C;EAC7C;;EAEA;IACE,4BAA4B;IAC5B,8CAA8C;IAC9C,+CAA+C;IAC/C,4CAA4C;IAC5C,sDAAsD;IACtD,kCAAkC;IAClC,yCAAyC;IACzC,wDAAwD;IACxD,+DAA+D;IAC/D,yCAAyC;IACzC,yDAAyD;IACzD,2DAA2D;IAC3D,0DAA0D;IAC1D,6DAA6D;IAC7D,4DAA4D;IAC5D,+BAA+B;IAC/B,2DAA2D;IAC3D,yDAAyD;IACzD,mEAAmE;IACnE,iEAAiE;IACjE,8BAA8B;IAC9B,0CAA0C;IAC1C,2CAA2C;EAC7C;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;IACX,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,4BAA4B;IAC5B,8CAA8C;IAC9C,+CAA+C;IAC/C,4CAA4C;IAC5C,sDAAsD;IACtD,kCAAkC;IAClC,yCAAyC;IACzC,wDAAwD;IACxD,+DAA+D;IAC/D,yCAAyC;IACzC,yDAAyD;IACzD,2DAA2D;IAC3D,2DAA2D;IAC3D,6DAA6D;IAC7D,4DAA4D;IAC5D,mCAAmC;IACnC,wDAAwD;IACxD,uDAAuD;IACvD,0DAA0D;IAC1D,yDAAyD;IACzD,kCAAkC;IAClC,kDAAkD;IAClD,8BAA8B;IAC9B,+CAA+C;IAC/C,qDAAqD;EACvD;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,kDAAkD;EACpD;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,oCAAoC;EACtC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,WAAW;IACX,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,6DAA6D;IAC7D,kBAAkB;EACpB;EACA;IACE,mEAAmE;EACrE;EACA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,6DAA6D;IAC7D,kBAAkB;EACpB;EACA;IACE,mEAAmE;EACrE;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,aAAa;IACb,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,WAAW;IACX,sDAAsD;IACtD,oHAAoH;IACpH,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,sDAAsD;EACxD;EACA;IACE,yDAAyD;EAC3D;EACA;IACE,uDAAuD;EACzD;EACA;IACE,wDAAwD;EAC1D;EACA;IACE,kBAAkB;IAClB,uDAAuD;EACzD;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,WAAW;IACX,UAAU;EACZ;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,yEAAyE;IACzE,mDAAmD;EACrD;EACA;IACE,wEAAwE;IACxE,kDAAkD;EACpD;EACA;IACE,2EAA2E;IAC3E,qDAAqD;EACvD;EACA;IACE,0EAA0E;IAC1E,oDAAoD;EACtD;;EAEA;;;KAGG;EACH;IACE,yEAAyE;IACzE,mDAAmD;EACrD;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,uDAAuD;IACvD,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;IACZ,aAAa;IACb,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;;IAEE,YAAY;IACZ,WAAW;EACb;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;;;;IAIE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,6CAA6C;IAC7C,yCAAyC;EAC3C;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;IACX,uBAAuB;IACvB,SAAS;IACT,SAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,wBAAwB;IACxB,UAAU;IACV,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,wBAAwB;IACxB,UAAU;IACV,WAAW;IACX,QAAQ;IACR,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,UAAU;IACV,SAAS;IACT,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,UAAU;IACV,WAAW;IACX,SAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,UAAU;IACV,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,UAAU;IACV,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,0BAA0B;IAC1B,oCAAoC;EACtC;EACA;IACE,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,4DAA4D;EAC9D;EACA;IACE,uDAAuD;IACvD,mDAAmD;IACnD,aAAa;IACb,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,sBAAsB;IACtB,yBAAiB;OAAjB,sBAAiB;YAAjB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,UAAU;IACV,WAAW;IACX,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB;IACpB,sDAAsD;EACxD;EACA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,UAAU;IACV,WAAW;IACX,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB;IACpB,sDAAsD;EACxD;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,WAAW;EACb;EACA;IACE,oBAAoB;EACtB;EACA;;IAEE,0BAA0B;IAC1B,oCAAoC;EACtC;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;IACZ,UAAU;EACZ;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,WAAW;EACb;EACA;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,6CAA6C;IAC7C,0DAA0D;EAC5D;EACA;IACE,0DAA0D;IAC1D,6CAA6C;IAC7C,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,4CAA4C;EAC9C;EACA;IACE,YAAY;IACZ,sBAAsB;IACtB,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;IACV,oBAAoB;IACpB,4CAA4C;EAC9C;EACA;IACE,qCAAqC,EAAE,sGAAsG;EAC/I;;EAEA;IACE,cAAc;EAChB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,QAAQ;IACR,SAAS;IACT,oBAAoB;IACpB,yDAAyD;IACzD,oBAAoB;IACpB,UAAU;EACZ;EACA;IACE,8DAA8D;EAChE;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,uDAAuD;EACzD;EACA;IACE,aAAa;IACb,uEAAuE;IACvE,cAAc;IACd,sBAAsB;IACtB,mDAAmD;IACnD,yDAAyD;EAC3D;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;IACb,YAAY;IACZ,YAAY;EACd;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,UAAU;IACV,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,uBAAuB;EACzB;EACA;IACE,oDAAoD;EACtD;EACA;IACE,0BAA0B;IAC1B,aAAa;IACb,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;IACV,oBAAoB;IACpB,6CAA6C;IAC7C,UAAU;IACV,YAAY;EACd;EACA;IACE,aAAa;IACb,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;IACZ,WAAW;IACX,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,eAAe;IACf,kDAAkD;EACpD;EACA;IACE,kBAAkB;IAClB,uDAAuD;EACzD","sourcesContent":["/* @import './node_modules/dockview/dist/styles/dockview.css'; */\n\n/* Custom added */\n.split-view-container .view-container {\n    background-color: rgb(250 250 250 / var(--tw-bg-opacity)) !important;\n  }\n\n  .dockview-theme-replit .groupview.active-group {\n    border: 1px solid transparent !important;\n  }\n  .dockview-theme-replit .groupview.inactive-group {\n    border: 1px solid transparent !important;\n  }\n/* Custom added end */\n\n.dockview-svg {\n    display: inline-block;\n    fill: currentcolor;\n    line-height: 1;\n    stroke: currentcolor;\n    stroke-width: 0;\n  }\n  .dockview-theme-dark {\n    --dv-background-color: black;\n    --dv-paneview-active-outline-color: dodgerblue;\n    --dv-tabs-and-actions-container-font-size: 13px;\n    --dv-tabs-and-actions-container-height: 35px;\n    --dv-drag-over-background-color: rgba(83, 89, 93, 0.5);\n    --dv-drag-over-border-color: white;\n    --dv-tabs-container-scrollbar-color: #888;\n    --dv-icon-hover-background-color: rgba(90, 93, 94, 0.31);\n    --dv-floating-box-shadow: 8px 8px 8px 0px rgba(83, 89, 93, 0.5);\n    --dv-group-view-background-color: #1e1e1e;\n    --dv-tabs-and-actions-container-background-color: #252526;\n    --dv-activegroup-visiblepanel-tab-background-color: #1e1e1e;\n    --dv-activegroup-hiddenpanel-tab-background-color: #2d2d2d;\n    --dv-inactivegroup-visiblepanel-tab-background-color: #1e1e1e;\n    --dv-inactivegroup-hiddenpanel-tab-background-color: #2d2d2d;\n    --dv-tab-divider-color: #1e1e1e;\n    --dv-activegroup-visiblepanel-tab-color: white;\n    --dv-activegroup-hiddenpanel-tab-color: #969696;\n    --dv-inactivegroup-visiblepanel-tab-color: #8f8f8f;\n    --dv-inactivegroup-hiddenpanel-tab-color: #626262;\n    --dv-separator-border: rgb(68, 68, 68);\n    --dv-paneview-header-border-color: rgba(204, 204, 204, 0.2);\n  }\n  \n  .dockview-theme-light {\n    --dv-background-color: black;\n    --dv-paneview-active-outline-color: dodgerblue;\n    --dv-tabs-and-actions-container-font-size: 13px;\n    --dv-tabs-and-actions-container-height: 35px;\n    --dv-drag-over-background-color: rgba(83, 89, 93, 0.5);\n    --dv-drag-over-border-color: white;\n    --dv-tabs-container-scrollbar-color: #888;\n    --dv-icon-hover-background-color: rgba(90, 93, 94, 0.31);\n    --dv-floating-box-shadow: 8px 8px 8px 0px rgba(83, 89, 93, 0.5);\n    --dv-group-view-background-color: white;\n    --dv-tabs-and-actions-container-background-color: #f3f3f3;\n    --dv-activegroup-visiblepanel-tab-background-color: white;\n    --dv-activegroup-hiddenpanel-tab-background-color: #ececec;\n    --dv-inactivegroup-visiblepanel-tab-background-color: white;\n    --dv-inactivegroup-hiddenpanel-tab-background-color: #ececec;\n    --dv-tab-divider-color: white;\n    --dv-activegroup-visiblepanel-tab-color: rgb(51, 51, 51);\n    --dv-activegroup-hiddenpanel-tab-color: rgba(51, 51, 51, 0.7);\n    --dv-inactivegroup-visiblepanel-tab-color: rgba(51, 51, 51, 0.7);\n    --dv-inactivegroup-hiddenpanel-tab-color: rgba(51, 51, 51, 0.35);\n    --dv-separator-border: rgba(128, 128, 128, 0.35);\n    --dv-paneview-header-border-color: rgb(51, 51, 51);\n  }\n  \n  .dockview-theme-vs {\n    --dv-background-color: black;\n    --dv-paneview-active-outline-color: dodgerblue;\n    --dv-tabs-and-actions-container-font-size: 13px;\n    --dv-tabs-and-actions-container-height: 35px;\n    --dv-drag-over-background-color: rgba(83, 89, 93, 0.5);\n    --dv-drag-over-border-color: white;\n    --dv-tabs-container-scrollbar-color: #888;\n    --dv-icon-hover-background-color: rgba(90, 93, 94, 0.31);\n    --dv-floating-box-shadow: 8px 8px 8px 0px rgba(83, 89, 93, 0.5);\n    --dv-group-view-background-color: #1e1e1e;\n    --dv-tabs-and-actions-container-background-color: #252526;\n    --dv-activegroup-visiblepanel-tab-background-color: #1e1e1e;\n    --dv-activegroup-hiddenpanel-tab-background-color: #2d2d2d;\n    --dv-inactivegroup-visiblepanel-tab-background-color: #1e1e1e;\n    --dv-inactivegroup-hiddenpanel-tab-background-color: #2d2d2d;\n    --dv-tab-divider-color: #1e1e1e;\n    --dv-activegroup-visiblepanel-tab-color: white;\n    --dv-activegroup-hiddenpanel-tab-color: #969696;\n    --dv-inactivegroup-visiblepanel-tab-color: #8f8f8f;\n    --dv-inactivegroup-hiddenpanel-tab-color: #626262;\n    --dv-separator-border: rgb(68, 68, 68);\n    --dv-paneview-header-border-color: rgba(204, 204, 204, 0.2);\n    --dv-tabs-and-actions-container-background-color: #2d2d30;\n    --dv-tabs-and-actions-container-height: 20px;\n    --dv-tabs-and-actions-container-font-size: 11px;\n    --dv-activegroup-visiblepanel-tab-background-color: #007acc;\n    --dv-inactivegroup-visiblepanel-tab-background-color: #3f3f46;\n    --dv-activegroup-visiblepanel-tab-color: white;\n    --dv-activegroup-hiddenpanel-tab-color: white;\n    --dv-inactivegroup-visiblepanel-tab-color: white;\n    --dv-inactivegroup-hiddenpanel-tab-color: white;\n  }\n  .dockview-theme-vs .groupview.active-group > .tabs-and-actions-container {\n    box-sizing: content-box;\n    border-bottom: 2px solid var(--dv-activegroup-visiblepanel-tab-background-color);\n  }\n  .dockview-theme-vs .groupview.active-group > .tabs-and-actions-container .tab.active-tab {\n    border-top: 2px solid var(--dv-activegroup-visiblepanel-tab-background-color);\n  }\n  .dockview-theme-vs .groupview.active-group > .tabs-and-actions-container .tab.inactive-tab {\n    border-top: 2px solid var(--dv-activegroup-hiddenpanel-tab-background-color);\n  }\n  .dockview-theme-vs .groupview.inactive-group > .tabs-and-actions-container {\n    box-sizing: content-box;\n    border-bottom: 2px solid var(--dv-inactivegroup-visiblepanel-tab-background-color);\n  }\n  .dockview-theme-vs .groupview.inactive-group > .tabs-and-actions-container .tab.active-tab {\n    border-top: 2px solid var(--dv-inactivegroup-visiblepanel-tab-background-color);\n  }\n  .dockview-theme-vs .groupview.inactive-group > .tabs-and-actions-container .tab.inactive-tab {\n    border-top: 2px solid var(--dv-inactivegroup-hiddenpanel-tab-background-color);\n  }\n  \n  .dockview-theme-abyss {\n    --dv-background-color: black;\n    --dv-paneview-active-outline-color: dodgerblue;\n    --dv-tabs-and-actions-container-font-size: 13px;\n    --dv-tabs-and-actions-container-height: 35px;\n    --dv-drag-over-background-color: rgba(83, 89, 93, 0.5);\n    --dv-drag-over-border-color: white;\n    --dv-tabs-container-scrollbar-color: #888;\n    --dv-icon-hover-background-color: rgba(90, 93, 94, 0.31);\n    --dv-floating-box-shadow: 8px 8px 8px 0px rgba(83, 89, 93, 0.5);\n    --dv-group-view-background-color: #000c18;\n    --dv-tabs-and-actions-container-background-color: #1c1c2a;\n    --dv-activegroup-visiblepanel-tab-background-color: #000c18;\n    --dv-activegroup-hiddenpanel-tab-background-color: #10192c;\n    --dv-inactivegroup-visiblepanel-tab-background-color: #000c18;\n    --dv-inactivegroup-hiddenpanel-tab-background-color: #10192c;\n    --dv-tab-divider-color: #2b2b4a;\n    --dv-activegroup-visiblepanel-tab-color: white;\n    --dv-activegroup-hiddenpanel-tab-color: rgba(255, 255, 255, 0.5);\n    --dv-inactivegroup-visiblepanel-tab-color: rgba(255, 255, 255, 0.5);\n    --dv-inactivegroup-hiddenpanel-tab-color: rgba(255, 255, 255, 0.25);\n    --dv-separator-border: #2b2b4a;\n    --dv-paneview-header-border-color: #2b2b4a;\n    --dv-paneview-active-outline-color: #596f99;\n  }\n  \n  .dockview-theme-dracula {\n    --dv-background-color: black;\n    --dv-paneview-active-outline-color: dodgerblue;\n    --dv-tabs-and-actions-container-font-size: 13px;\n    --dv-tabs-and-actions-container-height: 35px;\n    --dv-drag-over-background-color: rgba(83, 89, 93, 0.5);\n    --dv-drag-over-border-color: white;\n    --dv-tabs-container-scrollbar-color: #888;\n    --dv-icon-hover-background-color: rgba(90, 93, 94, 0.31);\n    --dv-floating-box-shadow: 8px 8px 8px 0px rgba(83, 89, 93, 0.5);\n    --dv-group-view-background-color: #282a36;\n    --dv-tabs-and-actions-container-background-color: #191a21;\n    --dv-activegroup-visiblepanel-tab-background-color: #282a36;\n    --dv-activegroup-hiddenpanel-tab-background-color: #21222c;\n    --dv-inactivegroup-visiblepanel-tab-background-color: #282a36;\n    --dv-inactivegroup-hiddenpanel-tab-background-color: #21222c;\n    --dv-tab-divider-color: #191a21;\n    --dv-activegroup-visiblepanel-tab-color: rgb(248, 248, 242);\n    --dv-activegroup-hiddenpanel-tab-color: rgb(98, 114, 164);\n    --dv-inactivegroup-visiblepanel-tab-color: rgba(248, 248, 242, 0.5);\n    --dv-inactivegroup-hiddenpanel-tab-color: rgba(98, 114, 164, 0.5);\n    --dv-separator-border: #bd93f9;\n    --dv-paneview-header-border-color: #bd93f9;\n    --dv-paneview-active-outline-color: #6272a4;\n  }\n  .dockview-theme-dracula .groupview.active-group > .tabs-and-actions-container > .tabs-container > .tab.active-tab {\n    position: relative;\n  }\n  .dockview-theme-dracula .groupview.active-group > .tabs-and-actions-container > .tabs-container > .tab.active-tab::after {\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    content: \"\";\n    width: 100%;\n    height: 1px;\n    background-color: #94527e;\n    z-index: 999;\n  }\n  .dockview-theme-dracula .groupview.inactive-group > .tabs-and-actions-container > .tabs-container > .tab.active-tab {\n    position: relative;\n  }\n  .dockview-theme-dracula .groupview.inactive-group > .tabs-and-actions-container > .tabs-container > .tab.active-tab::after {\n    position: absolute;\n    left: 0px;\n    bottom: 0px;\n    content: \"\";\n    width: 100%;\n    height: 1px;\n    background-color: #5e3d5a;\n    z-index: 999;\n  }\n  \n  .dockview-theme-replit {\n    --dv-background-color: black;\n    --dv-paneview-active-outline-color: dodgerblue;\n    --dv-tabs-and-actions-container-font-size: 13px;\n    --dv-tabs-and-actions-container-height: 35px;\n    --dv-drag-over-background-color: rgba(83, 89, 93, 0.5);\n    --dv-drag-over-border-color: white;\n    --dv-tabs-container-scrollbar-color: #888;\n    --dv-icon-hover-background-color: rgba(90, 93, 94, 0.31);\n    --dv-floating-box-shadow: 8px 8px 8px 0px rgba(83, 89, 93, 0.5);\n    --dv-group-view-background-color: #ebeced;\n    --dv-tabs-and-actions-container-background-color: #fcfcfc;\n    --dv-activegroup-visiblepanel-tab-background-color: #f0f1f2;\n    --dv-activegroup-hiddenpanel-tab-background-color: ##fcfcfc;\n    --dv-inactivegroup-visiblepanel-tab-background-color: #f0f1f2;\n    --dv-inactivegroup-hiddenpanel-tab-background-color: #fcfcfc;\n    --dv-tab-divider-color: transparent;\n    --dv-activegroup-visiblepanel-tab-color: rgb(51, 51, 51);\n    --dv-activegroup-hiddenpanel-tab-color: rgb(51, 51, 51);\n    --dv-inactivegroup-visiblepanel-tab-color: rgb(51, 51, 51);\n    --dv-inactivegroup-hiddenpanel-tab-color: rgb(51, 51, 51);\n    --dv-separator-border: transparent;\n    --dv-paneview-header-border-color: rgb(51, 51, 51);\n    --dv-background-color: #ebeced;\n    --dv-separator-handle-background-color: #cfd1d3;\n    --dv-separator-handle-hover-background-color: #babbbb;\n  }\n  .dockview-theme-replit .dv-resize-container:has(> .groupview) {\n    border-radius: 8px;\n  }\n  .dockview-theme-replit .groupview {\n    overflow: hidden;\n    border-radius: 10px;\n  }\n  .dockview-theme-replit .groupview .tabs-and-actions-container {\n    border-bottom: 1px solid rgba(128, 128, 128, 0.35);\n  }\n  .dockview-theme-replit .groupview .tabs-and-actions-container .tab {\n    margin: 4px;\n    border-radius: 8px;\n  }\n  .dockview-theme-replit .groupview .tabs-and-actions-container .tab .dockview-svg {\n    height: 8px;\n    width: 8px;\n  }\n  .dockview-theme-replit .groupview .tabs-and-actions-container .tab:hover {\n    background-color: #e4e5e6 !important;\n  }\n  .dockview-theme-replit .groupview .content-container {\n    background-color: #fcfcfc;\n  }\n  .dockview-theme-replit .groupview.active-group {\n    border: 1px solid rgba(128, 128, 128, 0.35);\n  }\n  .dockview-theme-replit .groupview.inactive-group {\n    border: 1px solid transparent;\n  }\n  .dockview-theme-replit .vertical > .sash-container > .sash:not(.disabled)::after {\n    content: \"\";\n    height: 4px;\n    width: 40px;\n    border-radius: 2px;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background-color: var(--dv-separator-handle-background-color);\n    position: absolute;\n  }\n  .dockview-theme-replit .vertical > .sash-container > .sash:not(.disabled):hover::after {\n    background-color: var(--dv-separator-handle-hover-background-color);\n  }\n  .dockview-theme-replit .horizontal > .sash-container > .sash:not(.disabled)::after {\n    content: \"\";\n    height: 40px;\n    width: 4px;\n    border-radius: 2px;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background-color: var(--dv-separator-handle-background-color);\n    position: absolute;\n  }\n  .dockview-theme-replit .horizontal > .sash-container > .sash:not(.disabled):hover::after {\n    background-color: var(--dv-separator-handle-hover-background-color);\n  }\n  .drop-target {\n    position: relative;\n  }\n  .drop-target > .drop-target-dropzone {\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    height: 100%;\n    width: 100%;\n    z-index: 1000;\n    pointer-events: none;\n  }\n  .drop-target > .drop-target-dropzone > .drop-target-selection {\n    position: relative;\n    box-sizing: border-box;\n    height: 100%;\n    width: 100%;\n    background-color: var(--dv-drag-over-background-color);\n    transition: top 70ms ease-out, left 70ms ease-out, width 70ms ease-out, height 70ms ease-out, opacity 0.15s ease-out;\n    will-change: transform;\n    pointer-events: none;\n  }\n  .drop-target > .drop-target-dropzone > .drop-target-selection.dv-drop-target-top.dv-drop-target-small-vertical {\n    border-top: 1px solid var(--dv-drag-over-border-color);\n  }\n  .drop-target > .drop-target-dropzone > .drop-target-selection.dv-drop-target-bottom.dv-drop-target-small-vertical {\n    border-bottom: 1px solid var(--dv-drag-over-border-color);\n  }\n  .drop-target > .drop-target-dropzone > .drop-target-selection.dv-drop-target-left.dv-drop-target-small-horizontal {\n    border-left: 1px solid var(--dv-drag-over-border-color);\n  }\n  .drop-target > .drop-target-dropzone > .drop-target-selection.dv-drop-target-right.dv-drop-target-small-horizontal {\n    border-right: 1px solid var(--dv-drag-over-border-color);\n  }\n  .dv-dockview {\n    position: relative;\n    background-color: var(--dv-group-view-background-color);\n  }\n  .dv-dockview .dv-watermark-container {\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    height: 100%;\n    width: 100%;\n    z-index: 1;\n  }\n  .dv-dockview .dv-overlay-render-container {\n    position: relative;\n  }\n  \n  .groupview.active-group > .tabs-and-actions-container > .tabs-container > .tab.active-tab {\n    background-color: var(--dv-activegroup-visiblepanel-tab-background-color);\n    color: var(--dv-activegroup-visiblepanel-tab-color);\n  }\n  .groupview.active-group > .tabs-and-actions-container > .tabs-container > .tab.inactive-tab {\n    background-color: var(--dv-activegroup-hiddenpanel-tab-background-color);\n    color: var(--dv-activegroup-hiddenpanel-tab-color);\n  }\n  .groupview.inactive-group > .tabs-and-actions-container > .tabs-container > .tab.active-tab {\n    background-color: var(--dv-inactivegroup-visiblepanel-tab-background-color);\n    color: var(--dv-inactivegroup-visiblepanel-tab-color);\n  }\n  .groupview.inactive-group > .tabs-and-actions-container > .tabs-container > .tab.inactive-tab {\n    background-color: var(--dv-inactivegroup-hiddenpanel-tab-background-color);\n    color: var(--dv-inactivegroup-hiddenpanel-tab-color);\n  }\n  \n  /**\n   * when a tab is dragged we lose the above stylings because they are conditional on parent elements\n   * therefore we also set some stylings for the dragging event\n   **/\n  .tab.dv-tab-dragging {\n    background-color: var(--dv-activegroup-visiblepanel-tab-background-color);\n    color: var(--dv-activegroup-visiblepanel-tab-color);\n  }\n  .groupview {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    background-color: var(--dv-group-view-background-color);\n    overflow: hidden;\n  }\n  .groupview:focus {\n    outline: none;\n  }\n  .groupview.empty > .tabs-and-actions-container {\n    display: none;\n  }\n  .groupview > .content-container {\n    flex-grow: 1;\n    min-height: 0;\n    outline: none;\n  }\n  .dv-root-wrapper {\n    height: 100%;\n    width: 100%;\n  }\n  .grid-view,\n  .branch-node {\n    height: 100%;\n    width: 100%;\n  }\n  .dv-debug .dv-resize-container .dv-resize-handle-top {\n    background-color: red;\n  }\n  .dv-debug .dv-resize-container .dv-resize-handle-bottom {\n    background-color: green;\n  }\n  .dv-debug .dv-resize-container .dv-resize-handle-left {\n    background-color: yellow;\n  }\n  .dv-debug .dv-resize-container .dv-resize-handle-right {\n    background-color: blue;\n  }\n  .dv-debug .dv-resize-container .dv-resize-handle-topleft,\n  .dv-debug .dv-resize-container .dv-resize-handle-topright,\n  .dv-debug .dv-resize-container .dv-resize-handle-bottomleft,\n  .dv-debug .dv-resize-container .dv-resize-handle-bottomright {\n    background-color: cyan;\n  }\n  \n  .dv-resize-container {\n    position: absolute;\n    z-index: 997;\n    border: 1px solid var(--dv-tab-divider-color);\n    box-shadow: var(--dv-floating-box-shadow);\n  }\n  .dv-resize-container.dv-resize-container-dragging {\n    opacity: 0.5;\n  }\n  .dv-resize-container .dv-resize-handle-top {\n    height: 4px;\n    width: calc(100% - 8px);\n    left: 4px;\n    top: -2px;\n    z-index: 999;\n    position: absolute;\n    cursor: ns-resize;\n  }\n  .dv-resize-container .dv-resize-handle-bottom {\n    height: 4px;\n    width: calc(100% - 8px);\n    left: 4px;\n    bottom: -2px;\n    z-index: 999;\n    position: absolute;\n    cursor: ns-resize;\n  }\n  .dv-resize-container .dv-resize-handle-left {\n    height: calc(100% - 8px);\n    width: 4px;\n    left: -2px;\n    top: 4px;\n    z-index: 999;\n    position: absolute;\n    cursor: ew-resize;\n  }\n  .dv-resize-container .dv-resize-handle-right {\n    height: calc(100% - 8px);\n    width: 4px;\n    right: -2px;\n    top: 4px;\n    z-index: 999;\n    position: absolute;\n    cursor: ew-resize;\n  }\n  .dv-resize-container .dv-resize-handle-topleft {\n    height: 4px;\n    width: 4px;\n    top: -2px;\n    left: -2px;\n    z-index: 999;\n    position: absolute;\n    cursor: nw-resize;\n  }\n  .dv-resize-container .dv-resize-handle-topright {\n    height: 4px;\n    width: 4px;\n    right: -2px;\n    top: -2px;\n    z-index: 999;\n    position: absolute;\n    cursor: ne-resize;\n  }\n  .dv-resize-container .dv-resize-handle-bottomleft {\n    height: 4px;\n    width: 4px;\n    left: -2px;\n    bottom: -2px;\n    z-index: 999;\n    position: absolute;\n    cursor: sw-resize;\n  }\n  .dv-resize-container .dv-resize-handle-bottomright {\n    height: 4px;\n    width: 4px;\n    right: -2px;\n    bottom: -2px;\n    z-index: 999;\n    position: absolute;\n    cursor: se-resize;\n  }\n  .dv-render-overlay {\n    position: absolute;\n    z-index: 1;\n    height: 100%;\n  }\n  .dv-render-overlay.dv-render-overlay-float {\n    z-index: 998;\n  }\n  .dv-debug .dv-render-overlay {\n    outline: 1px solid red;\n    outline-offset: -1;\n  }\n  .pane-container {\n    height: 100%;\n    width: 100%;\n  }\n  .pane-container.animated .view {\n    transition-duration: 0.15s;\n    transition-timing-function: ease-out;\n  }\n  .pane-container .view {\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    padding: 0px !important;\n  }\n  .pane-container .view:not(:first-child)::before {\n    background-color: transparent !important;\n  }\n  .pane-container .view:not(:first-child) .pane > .pane-header {\n    border-top: 1px solid var(--dv-paneview-header-border-color);\n  }\n  .pane-container .view .default-header {\n    background-color: var(--dv-group-view-background-color);\n    color: var(--dv-activegroup-visiblepanel-tab-color);\n    display: flex;\n    padding: 0px 8px;\n    cursor: pointer;\n  }\n  .pane-container .view .default-header .dockview-pane-header-icon {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  .pane-container .view .default-header > span {\n    padding-left: 8px;\n    flex-grow: 1;\n  }\n  .pane-container:first-of-type > .pane > .pane-header {\n    border-top: none !important;\n  }\n  .pane-container .pane {\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    height: 100%;\n  }\n  .pane-container .pane .pane-header {\n    box-sizing: border-box;\n    user-select: none;\n    position: relative;\n    outline: none;\n  }\n  .pane-container .pane .pane-header.pane-draggable {\n    cursor: pointer;\n  }\n  .pane-container .pane .pane-header:focus:before, .pane-container .pane .pane-header:focus-within:before {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 5;\n    content: \"\";\n    pointer-events: none;\n    outline: 1px solid;\n    outline-width: -1px;\n    outline-style: solid;\n    outline-offset: -1px;\n    outline-color: var(--dv-paneview-active-outline-color);\n  }\n  .pane-container .pane .pane-body {\n    overflow-y: auto;\n    overflow-x: hidden;\n    flex-grow: 1;\n    position: relative;\n    outline: none;\n  }\n  .pane-container .pane .pane-body:focus:before, .pane-container .pane .pane-body:focus-within:before {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 5;\n    content: \"\";\n    pointer-events: none;\n    outline: 1px solid;\n    outline-width: -1px;\n    outline-style: solid;\n    outline-offset: -1px;\n    outline-color: var(--dv-paneview-active-outline-color);\n  }\n  .dv-debug .split-view-container .sash-container .sash.enabled {\n    background-color: black;\n  }\n  .dv-debug .split-view-container .sash-container .sash.disabled {\n    background-color: orange;\n  }\n  .dv-debug .split-view-container .sash-container .sash.maximum {\n    background-color: green;\n  }\n  .dv-debug .split-view-container .sash-container .sash.minimum {\n    background-color: red;\n  }\n  \n  .split-view-container {\n    position: relative;\n    overflow: hidden;\n    height: 100%;\n    width: 100%;\n  }\n  .split-view-container.dv-splitview-disabled > .sash-container > .sash {\n    pointer-events: none;\n  }\n  .split-view-container.animation .view,\n  .split-view-container.animation .sash {\n    transition-duration: 0.15s;\n    transition-timing-function: ease-out;\n  }\n  .split-view-container.horizontal {\n    height: 100%;\n  }\n  .split-view-container.horizontal > .sash-container > .sash {\n    height: 100%;\n    width: 4px;\n  }\n  .split-view-container.horizontal > .sash-container > .sash.enabled {\n    cursor: ew-resize;\n  }\n  .split-view-container.horizontal > .sash-container > .sash.disabled {\n    cursor: default;\n  }\n  .split-view-container.horizontal > .sash-container > .sash.maximum {\n    cursor: w-resize;\n  }\n  .split-view-container.horizontal > .sash-container > .sash.minimum {\n    cursor: e-resize;\n  }\n  .split-view-container.horizontal > .view-container > .view:not(:first-child)::before {\n    height: 100%;\n    width: 1px;\n  }\n  .split-view-container.vertical {\n    width: 100%;\n  }\n  .split-view-container.vertical > .sash-container > .sash {\n    width: 100%;\n    height: 4px;\n  }\n  .split-view-container.vertical > .sash-container > .sash.enabled {\n    cursor: ns-resize;\n  }\n  .split-view-container.vertical > .sash-container > .sash.disabled {\n    cursor: default;\n  }\n  .split-view-container.vertical > .sash-container > .sash.maximum {\n    cursor: n-resize;\n  }\n  .split-view-container.vertical > .sash-container > .sash.minimum {\n    cursor: s-resize;\n  }\n  .split-view-container.vertical > .view-container > .view {\n    width: 100%;\n  }\n  .split-view-container.vertical > .view-container > .view:not(:first-child)::before {\n    height: 1px;\n    width: 100%;\n  }\n  .split-view-container .sash-container {\n    height: 100%;\n    width: 100%;\n    position: absolute;\n  }\n  .split-view-container .sash-container .sash {\n    position: absolute;\n    z-index: 99;\n    outline: none;\n    user-select: none;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    touch-action: none;\n  }\n  .split-view-container .sash-container .sash:not(.disabled):active {\n    transition: background-color 0.1s ease-in-out;\n    background-color: var(--dv-active-sash-color, transparent);\n  }\n  .split-view-container .sash-container .sash:not(.disabled):hover {\n    background-color: var(--dv-active-sash-color, transparent);\n    transition: background-color 0.1s ease-in-out;\n    transition-delay: 0.5s;\n  }\n  .split-view-container .view-container {\n    position: relative;\n    height: 100%;\n    width: 100%;\n    background-color: var(--dv-background-color);\n  }\n  .split-view-container .view-container .view {\n    height: 100%;\n    box-sizing: border-box;\n    overflow: auto;\n    position: absolute;\n  }\n  .split-view-container.separator-border .view:not(:first-child)::before {\n    content: \" \";\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 5;\n    pointer-events: none;\n    background-color: var(--dv-separator-border);\n  }\n  .dv-dragged {\n    transform: translate3d(0px, 0px, 0px); /* forces tab to be drawn on a separate layer (see https://github.com/microsoft/vscode/issues/18733) */\n  }\n  \n  .tab {\n    flex-shrink: 0;\n  }\n  .tab:focus-within, .tab:focus {\n    position: relative;\n  }\n  .tab:focus-within::after, .tab:focus::after {\n    position: absolute;\n    content: \"\";\n    height: 100%;\n    width: 100%;\n    top: 0px;\n    left: 0px;\n    pointer-events: none;\n    outline: 1px solid var(--dv-tab-divider-color) !important;\n    outline-offset: -1px;\n    z-index: 5;\n  }\n  .tab.dv-tab-dragging .dv-default-tab-action {\n    background-color: var(--dv-activegroup-visiblepanel-tab-color);\n  }\n  .tab.active-tab .dv-default-tab .dv-default-tab-action {\n    visibility: visible;\n  }\n  .tab.inactive-tab .dv-default-tab .dv-default-tab-action {\n    visibility: hidden;\n  }\n  .tab.inactive-tab .dv-default-tab:hover .dv-default-tab-action {\n    visibility: visible;\n  }\n  .tab .dv-default-tab {\n    position: relative;\n    height: 100%;\n    display: flex;\n    min-width: 80px;\n    align-items: center;\n    padding: 0px 8px;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n  .tab .dv-default-tab .dv-default-tab-content {\n    padding: 0px 8px;\n    flex-grow: 1;\n  }\n  .tab .dv-default-tab .dv-default-tab-action {\n    padding: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-sizing: border-box;\n  }\n  .tab .dv-default-tab .dv-default-tab-action:hover {\n    border-radius: 2px;\n    background-color: var(--dv-icon-hover-background-color);\n  }\n  .tabs-and-actions-container {\n    display: flex;\n    background-color: var(--dv-tabs-and-actions-container-background-color);\n    flex-shrink: 0;\n    box-sizing: border-box;\n    height: var(--dv-tabs-and-actions-container-height);\n    font-size: var(--dv-tabs-and-actions-container-font-size);\n  }\n  .tabs-and-actions-container.hidden {\n    display: none;\n  }\n  .tabs-and-actions-container.dv-single-tab.dv-full-width-single-tab .tabs-container {\n    flex-grow: 1;\n  }\n  .tabs-and-actions-container.dv-single-tab.dv-full-width-single-tab .tabs-container .tab {\n    flex-grow: 1;\n  }\n  .tabs-and-actions-container.dv-single-tab.dv-full-width-single-tab .void-container {\n    flex-grow: 0;\n  }\n  .tabs-and-actions-container .void-container {\n    display: flex;\n    flex-grow: 1;\n    cursor: grab;\n  }\n  .tabs-and-actions-container .tabs-container {\n    display: flex;\n    overflow-x: overlay;\n    overflow-y: hidden;\n    scrollbar-width: thin;\n    /* Track */\n    /* Handle */\n  }\n  .tabs-and-actions-container .tabs-container::-webkit-scrollbar {\n    height: 3px;\n  }\n  .tabs-and-actions-container .tabs-container::-webkit-scrollbar-track {\n    background: transparent;\n  }\n  .tabs-and-actions-container .tabs-container::-webkit-scrollbar-thumb {\n    background: var(--dv-tabs-container-scrollbar-color);\n  }\n  .tabs-and-actions-container .tabs-container .tab {\n    -webkit-user-drag: element;\n    outline: none;\n    min-width: 75px;\n    cursor: pointer;\n    position: relative;\n    box-sizing: border-box;\n  }\n  .tabs-and-actions-container .tabs-container .tab:not(:first-child)::before {\n    content: \" \";\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 5;\n    pointer-events: none;\n    background-color: var(--dv-tab-divider-color);\n    width: 1px;\n    height: 100%;\n  }\n  .watermark {\n    display: flex;\n    width: 100%;\n  }\n  .watermark.has-actions .watermark-title .actions-container {\n    display: none;\n  }\n  .watermark .watermark-title {\n    height: 35px;\n    width: 100%;\n    display: flex;\n  }\n  .watermark .watermark-content {\n    flex-grow: 1;\n  }\n  .watermark .actions-container {\n    display: flex;\n    align-items: center;\n    padding: 0px 8px;\n  }\n  .watermark .actions-container .close-action {\n    padding: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-sizing: border-box;\n    cursor: pointer;\n    color: var(--dv-activegroup-hiddenpanel-tab-color);\n  }\n  .watermark .actions-container .close-action:hover {\n    border-radius: 2px;\n    background-color: var(--dv-icon-hover-background-color);\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
